var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTacitKnowledgePopUpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1554.66 354.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c7e1a6;}.cls-2{fill:#a0cf6d;}.cls-3{fill:#739748;}.cls-4{fill:#8ad4de;}.cls-5{fill:#35808a;}.cls-6{fill:#1ec0e9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.11,9.83h93.72v.1l-2,18.45-.1.1H651.22L637.4,151.18l-.1.1H618.75l-.09-.1,13.81-122.7H595l-.09-.1,2-18.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754,9.83q.29,0,6.09,20.77L796,151.18l-.19.1H775.58q-.39,0-2.13-6.47l-7.05-24H699.25L683.6,151.28h-20v-.1L725.82,30.51,736.54,9.83ZM709,102.1h51.78L742.05,38.33q-.28,0-13.53,26.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.93,9.83h.19q27.35,0,45.51,21.26,6.29,8.31,8.7,14.3-.87.68-17.4,9a57.68,57.68,0,0,0-6.57-10.92Q879,28.4,860.09,28.38q-19.22,0-35.84,15.27-16,16.14-18.26,36.81-2.7,24,13.72,40.87,12.56,11.21,28,11.21h2q17,0,33.33-14a70.35,70.35,0,0,0,10.24-12.08l15.36,8.6v.38a100.49,100.49,0,0,1-10.14,12.85q-23.58,23-52,23-28.21,0-46.76-22.61-15.37-21.34-12.47-47.82l.1-.58q2.89-26.76,23.28-48.51Q834.1,9.35,861.93,9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.32,9.83h18.45v.1L937.93,151.18l-.1.1H919.38l-.1-.1L935.13,9.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.48,9.83h93.72v.1l-2,18.45-.09.1h-37.49l-13.82,122.7-.09.1H995.13l-.1-.1,13.82-122.7H971.36l-.1-.1,2-18.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.09,199.85h13.28V259.4h12.32l46.47-59.55h16.5l-51.78,66.38,57.47,70.93H667.28l-52.35-64.48H603.37v64.48H590.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.93,199.85H710l61.64,122.9H772V199.85h13.28V337.16h-21l-61.64-122.9h-.38v122.9H688.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.51,245.37c0-40.21,12.33-47,48.37-47s48.36,6.83,48.36,47v46.27c0,40.21-12.33,47-48.36,47s-48.37-6.83-48.37-47Zm83.45.75c0-30.34-4-34.51-35.08-34.51s-35.09,4.17-35.09,34.51v44.76c0,30.35,4,34.52,35.09,34.52S884,321.23,884,290.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.91,213.12h-.38L963,337.16H943.65L907.81,199.85H920.7l32.24,124h.38l30.35-124h20.1l30.35,124h.38l32.24-124h12.9l-35.85,137.31h-19.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.1,199.85h13.27v122.9h57.85v14.41H1086.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.91,199.85h73.58v13.27h-60.31V259.4h57.28v13.28h-57.28v51.2h59.93v13.28h-73.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.73,199.85h52.54c40.21,0,42.1,23.14,42.1,63.15,0,50.26-2.27,74.16-44,74.16h-50.64Zm13.28,124h41.53c22,0,26.56-11.76,26.56-55.38,0-45.14-4.18-55.38-26.56-55.38H1275Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.85,269.64h48.93v30.73c0,36.79-16.12,38.31-45.71,38.31-36,0-48.36-6.83-48.36-47V245.37c0-40.21,12.33-47,48.36-47,26.94,0,45.71,2.27,45.71,28.26v13.84h-13.27v-5c0-21.05-4.56-23.89-32.44-23.89-31.1,0-35.08,4.17-35.08,34.51v44.76c0,30.35,4,34.52,35.08,34.52,26.37,0,32.44-.19,32.44-28.83V282.92h-35.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.07,199.85h73.59v13.27h-60.31V259.4h57.27v13.28h-57.27v51.2h59.93v13.28h-73.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "504.79 354.07 504.37 353.67 494.87 1.27 295 154.5 274.35 134.86 495.28 0.83 504.79 354.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "504.37 353.67 295 154.5 494.87 1.27 504.37 353.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "504.39 354.5 248.43 190.2 295 154.5 504.37 353.67 504.39 354.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.07 0 216.87 28.54 0 26.88 221.07 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "269.61 28.94 169.92 347.65 216.87 28.54 269.61 28.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.87 28.54 169.92 347.65 0 26.88 216.87 28.54"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTacitKnowledgePopUpLogo);
export default __webpack_public_path__ + "static/media/TacitKnowledgePopUpLogo.4c7d5641.svg";
export { ForwardRef as ReactComponent };